/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { sysAPI } from "../apis/SysAPI";
import { DashboardTemplate } from "../templates/DashboardTemplate"
import { Icon, Pagination, Container, Table, Loader, Segment, Dimmer } from 'semantic-ui-react'
import { TabContainer } from '../components/shared/TabContainer';
import { useDispatch } from "react-redux";
import MessageTablesEmpty from "../components/globals/MessageTablesEmpty";
import moment from "../helpers/moment-helpers";
import Filters from "./DashboardAdvisorsView/Filters";
import { setSnackbar } from "../actions/snackbar.actions";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const DashboardAdvisorsSnapshotsView = () => {
    const dispatch = useDispatch();
    const pageSize = 15;
    const [filters, setFilters] = useState({
        mainCompanies: [],
        officeCompanies: [],
        excludeCompanies: [],
        searchInput: "",
        license: "",
        businessCategory: ""
    })
    const [loadingDownload, setLoadingDownload] = useState(false);
    const [advisorsList, setAdvisorsList] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [totalAdvisors, setTotalAdvisors] = useState(0);
    const [search, setSearch] = useState({activePage: 1, includeCompanies: '', excludeCompanies: '', searchInput: '', license: ''});

    const [sort, setSort] = useState('');
    const [sortType, setSortType] = useState('ASC');
    const [sortChange, setSortChange] = useState(0);

    const [isLoading, setIsLoading] = useState(false);
    const [counterSearched, setCounterSearched] = useState(-1)
    const [filterButtonIsDisabled, setFilterButtonIsDisabled] = useState(true)


    const apiCall = async (page=1) => {
        setIsLoading(true)
        setSearch({...search, activePage: page});
        try {
            if(filterButtonIsDisabled){
                // eslint-disable-next-line
                throw {message: "Not enough params"}
            }
            const response = await sysAPI.get(`/advisors`, {
                params:{
                    page,
                    size: pageSize,
                    query: filters.searchInput || undefined,
                    mainCompanies: filters.mainCompanies?.length ? filters.mainCompanies.join(",") : undefined,
                    officeCompanies: filters.officeCompanies?.length ? filters.officeCompanies.join(",") : undefined,
                    excludeCompanies: filters.excludeCompanies?.length ? filters.excludeCompanies.join(",") : undefined,
                    license: filters.license || undefined,
                    sort: sort,
                    sorttype: sortType,
                    businesscategory: filters.businessCategory || undefined,
                    withSnapshots: true
                }
            })
            const { advisorsList, totalPages, total } = response.data;
            // console.log(totalPages);
            setAdvisorsList(advisorsList);
            setTotalPages(totalPages);
            setTotalAdvisors(total);
            setCounterSearched(counterSearched+1)
        } catch (error) {
            const message = error?.response?.data?.message || error?.message || "Oops... something is wrong..."
            console.error(error);
            dispatch(setSnackbar({message, status: "error"}))
        }
        setIsLoading(false);
        setLoadingDownload(false);
    }

    const exportCall = async () => {
        setLoadingDownload(true);
        try {
            if(filterButtonIsDisabled){
                // eslint-disable-next-line
                throw {message: "Not enough params"}
            }
            const {data} = await sysAPI.get(`/advisors/export`,{
                params:{
                    query: filters.searchInput || undefined,
                    mainCompanies: filters.mainCompanies?.length ? filters.mainCompanies.join(",") : undefined,
                    officeCompanies: filters.officeCompanies?.length ? filters.officeCompanies.join(",") : undefined,
                    excludeCompanies: filters.excludeCompanies?.length ? filters.excludeCompanies.join(",") : undefined,
                    license: filters.license || undefined,
                    sort: sort,
                    sorttype: sortType,
                    businesscategory: filters.businessCategory || undefined,
                    withSnapshots: true,
                },
                responseType: "blob"
            })
            const href = URL.createObjectURL(data);
            const link = document.createElement("a");

            link.href = href;
            link.setAttribute('download', `Advisor Snapshots List ${moment().format('MM-DD-YYYY hh.mm.ss')}.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            //URL.removeObjectURL(href);
            dispatch(setSnackbar({message: "CSV downloaded"}))
        } catch (error) {
            const message = error?.response?.data?.message || error?.message || "Oops... something is wrong..."
            console.error(error);
            dispatch(setSnackbar({message, status: "error"}))
        }
        setIsLoading(false);
        setLoadingDownload(false);
    }

    useEffect(() => {
        if(sortChange > 0){
            apiCall(search.activePage)
        }
    }, [sortChange])

    const pageChange = (e, { activePage }) => {
        apiCall(activePage)
    }

    useEffect(() => {
        if(
            filters?.mainCompanies?.length ||
            filters?.excludeCompanies?.length ||
            filters?.license?.length ||
            filters?.businessCategory?.length ||
            filters?.searchInput?.length >= 3
        ){
            setFilterButtonIsDisabled(false)
        }else{
            setFilterButtonIsDisabled(true)
        }
    },[
        filters?.searchInput,
        filters?.mainCompanies,
        filters?.excludeCompanies,
        filters?.license,
        filters?.businessCategory,
    ])

    const sortColumn = (column) => {
        if(isLoading) {
            console.log('Wait please...')
            return
        }

        if (column === sort) {
            if(sortType === 'ASC'){
                setSortType('DESC')
            }
            else if(sortType === 'DESC') {
                setSort('');
                setSortType('')
            }
            else{
                setSortType('ASC')
            }
            setSortChange(sortChange + 1)
            return
        }

        setSort(column);
        setSortType('ASC');
        setSortChange(sortChange + 1)
    }

    const headersCell = [
        {label: "Home Snapshots", sortValue: "homeSnapshots"},
        {label: "Auto Snapshots", sortValue: "autoSnapshots"},
        {label: "Estate Snapshots", sortValue: "estateSnapshots"},
        {label: "Tax Snapshots", sortValue: "fulltaxSnapshots"},
        {label: "Total Snapshots", sortValue: "totalSnapshots"},
    ]

    return (
        <DashboardTemplate scope='advisors' permission="snapshots:snapshots_view">
            <TabContainer
                title='Advisors Snapshots'
                subtitle='Count Snapshots from Advisors'
            >
                <div>
                    <Filters filterButtonIsDisabled={filterButtonIsDisabled} filters={filters} setFilters={setFilters} handlerSearch={apiCall} handlerDownload={exportCall} loading={isLoading} loadingDownload={loadingDownload} />
                </div>
                <Table>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Full Name</Table.HeaderCell>
                            <Table.HeaderCell style={{maxWidth: '200px'}}>Email</Table.HeaderCell>
                            <Table.HeaderCell
                                className={`table-header__order ${sort === 'company' ? 'active' : ''}`}
                                onClick={() => sortColumn('company')}
                                style={{minWidth: '115px'}}
                            >
                                Company
                                {(sort === 'company' && sortType === 'ASC') && <Icon name="sort up" />}
                                {(sort === 'company' && sortType === 'DESC') && <Icon name="sort down" />}
                                {sort !== 'company' && <Icon name="sort" />}
                            </Table.HeaderCell>
                            <Table.HeaderCell
                                className={`table-header__order ${sort === 'poc' ? 'active' : ''}`}
                                onClick={() => sortColumn('poc')}
                            >
                                POC
                                {(sort === 'poc' && sortType === 'ASC') && <Icon name="sort up" />}
                                {(sort === 'poc' && sortType === 'DESC') && <Icon name="sort down" />}
                                {sort !== 'poc' && <Icon name="sort" />}
                            </Table.HeaderCell>
                            <Table.HeaderCell>Status</Table.HeaderCell>
                            <Table.HeaderCell>Business Category</Table.HeaderCell>
                            {headersCell.map((header) => (
                                <Table.HeaderCell
                                    className={`table-header__order ${sort === `${header.sortValue}` ? 'active' : ''}`}
                                    onClick={() => sortColumn(`${header.sortValue}`)}
                                >
                                    {header.label}
                                    {(sort === `${header.sortValue}` && sortType === 'ASC') && <Icon name="sort up" />}
                                    {(sort === `${header.sortValue}` && sortType === 'DESC') && <Icon name="sort down" />}
                                    {sort !== `${header.sortValue}` && <Icon name="sort" />}
                                </Table.HeaderCell>
                            ))}
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {isLoading ? (
                            <>
                                <Table.Row>
                                    <Table.Cell colSpan={11}>
                                        <Segment style={{ width: '100%', height: '300px' }}>
                                            <Dimmer active inverted>
                                                <Loader inverted>Loading</Loader>
                                            </Dimmer>
                                        </Segment>
                                    </Table.Cell>
                                </Table.Row>
                            </>
                        ) : (
                            <>
                                {advisorsList?.map(advisor => (
                                    <TableBodyRow advisor={advisor} />
                                ))}
                            </>
                        )}
                    </Table.Body>
                </Table>
                {!isLoading && advisorsList.length < 1 &&  <MessageTablesEmpty counterSearched={counterSearched} />}
                <Container
                    fluid
                    textAlign='right'
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: "flex-end",
                        alignItems: "center",
                        gap: '32px',
                    }}
                >
                    <div style={{ fontSize: '1.2em' }}>Total Advisors found: {totalAdvisors}</div>
                    <Pagination totalPages={totalPages} activePage={search.activePage} onPageChange={pageChange} disabled={isLoading} />
                </Container>
            </TabContainer>
        </DashboardTemplate>
    )
}

const TableBodyRow = ({advisor}) => {
    return (
        <Table.Row key={advisor._id} style={{ color: advisor.hasActiveSession ? 'green' : 'black' }}>
            <Table.Cell>
                <Link style={{ color: advisor.hasActiveSession ? 'green' : 'black' }} to={`/dashboard/advisors/${advisor._id}`}>{advisor.fullName}</Link>
            </Table.Cell>
            <Table.Cell>{advisor.email}</Table.Cell>
            <Table.Cell>
                <Link style={{ color: advisor.hasActiveSession ? 'green' : 'black' }} to={`/dashboard/companies/${advisor.companyInfo?._id}`}>{advisor.companyInfo?.name}</Link>
            </Table.Cell>
            <Table.Cell>{advisor.companyInfo?.pocUser?.fullName}</Table.Cell>
            <Table.Cell>{advisor.status}</Table.Cell>
            <Table.Cell>{advisor.businessCategory}</Table.Cell>
            <Table.Cell textAlign="center">{advisor.homeSnapshots || 0}</Table.Cell>
            <Table.Cell textAlign="center">{advisor.autoSnapshots || 0}</Table.Cell>
            <Table.Cell textAlign="center">{advisor.estateSnapshots || 0}</Table.Cell>
            <Table.Cell textAlign="center">{advisor.fulltaxSnapshots || 0}</Table.Cell>
            <Table.Cell textAlign="center">{advisor.totalSnapshots || 0}</Table.Cell>
        </Table.Row>
    )
}

export default DashboardAdvisorsSnapshotsView